import React from "react";

class Popup extends React.Component {
  state = {
    isShow: true
  };

  handleClose = () => {
    this.setState({ isShow: false });
  };

  render() {
    if (!this.state.isShow) {
      return null;
    }

    return (
      <div className="popup">
        <div className="cover">
          <div className="content">
            <h4 className="title">
              I’m the Best Coder! Challenge Campus Edition 2020 will be
              postponed
            </h4>
            <p>
              In light of the Government’s move to raise the DORSCON level for
              COVID-19 to Orange, the Singapore Ministry of Health has advised
              event organisers to cancel or defer large-scale events. Therefore,
              we regret to inform you that{" "}
              <i>I’m the Best Coder! Challenge Campus Edition 2020</i> has been
              postponed until further notice.
            </p>
            <p>
              Registration will remain open for all interested individuals. Do
              follow us on{" "}
              <a href="https://www.linkedin.com/company/shopee/">LinkedIn</a> to
              stay updated on Best Coder Campus.
            </p>
            <p>
              For other queries, please email us at <a href="techsg@shopee.com">techsg@shopee.com</a>.
            </p>
            <button className="ok-button" onClick={() => this.handleClose()}>
              OK
            </button>
          </div>
          <div className="x-button" onClick={() => this.handleClose()}></div>
        </div>
      </div>
    );
  }
}
export default Popup;
